import React from 'react';
import { useCountryStates } from '../hooks/useCountryStates';

/** The four countries supported by this platform (ISO codes as values). */
export const SUPPORTED_COUNTRIES = [
  { value: 'US', label: 'United States' },
  { value: 'GB', label: 'United Kingdom' },
  { value: 'CA', label: 'Canada' },
  { value: 'AU', label: 'Australia' },
];

/** Countries with full state/province dropdown support (by ISO code) */
export const COACH_COUNTRIES = ['US', 'CA', 'GB', 'AU'];

/** Full world country list (ISO-ish, sorted alphabetically) */
export const ALL_COUNTRIES = [
  { value: 'Afghanistan', label: 'Afghanistan' },
  { value: 'Albania', label: 'Albania' },
  { value: 'Algeria', label: 'Algeria' },
  { value: 'Andorra', label: 'Andorra' },
  { value: 'Angola', label: 'Angola' },
  { value: 'Argentina', label: 'Argentina' },
  { value: 'Armenia', label: 'Armenia' },
  { value: 'Australia', label: 'Australia' },
  { value: 'Austria', label: 'Austria' },
  { value: 'Azerbaijan', label: 'Azerbaijan' },
  { value: 'Bahamas', label: 'Bahamas' },
  { value: 'Bahrain', label: 'Bahrain' },
  { value: 'Bangladesh', label: 'Bangladesh' },
  { value: 'Belarus', label: 'Belarus' },
  { value: 'Belgium', label: 'Belgium' },
  { value: 'Belize', label: 'Belize' },
  { value: 'Benin', label: 'Benin' },
  { value: 'Bhutan', label: 'Bhutan' },
  { value: 'Bolivia', label: 'Bolivia' },
  { value: 'Bosnia and Herzegovina', label: 'Bosnia and Herzegovina' },
  { value: 'Botswana', label: 'Botswana' },
  { value: 'Brazil', label: 'Brazil' },
  { value: 'Brunei', label: 'Brunei' },
  { value: 'Bulgaria', label: 'Bulgaria' },
  { value: 'Burkina Faso', label: 'Burkina Faso' },
  { value: 'Burundi', label: 'Burundi' },
  { value: 'Cambodia', label: 'Cambodia' },
  { value: 'Cameroon', label: 'Cameroon' },
  { value: 'Canada', label: 'Canada' },
  { value: 'Cape Verde', label: 'Cape Verde' },
  { value: 'Central African Republic', label: 'Central African Republic' },
  { value: 'Chad', label: 'Chad' },
  { value: 'Chile', label: 'Chile' },
  { value: 'China', label: 'China' },
  { value: 'Colombia', label: 'Colombia' },
  { value: 'Comoros', label: 'Comoros' },
  { value: 'Congo', label: 'Congo' },
  { value: 'Costa Rica', label: 'Costa Rica' },
  { value: 'Croatia', label: 'Croatia' },
  { value: 'Cuba', label: 'Cuba' },
  { value: 'Cyprus', label: 'Cyprus' },
  { value: 'Czech Republic', label: 'Czech Republic' },
  { value: 'Denmark', label: 'Denmark' },
  { value: 'Djibouti', label: 'Djibouti' },
  { value: 'Dominican Republic', label: 'Dominican Republic' },
  { value: 'Ecuador', label: 'Ecuador' },
  { value: 'Egypt', label: 'Egypt' },
  { value: 'El Salvador', label: 'El Salvador' },
  { value: 'England', label: 'England' },
  { value: 'Eritrea', label: 'Eritrea' },
  { value: 'Estonia', label: 'Estonia' },
  { value: 'Eswatini', label: 'Eswatini' },
  { value: 'Ethiopia', label: 'Ethiopia' },
  { value: 'Fiji', label: 'Fiji' },
  { value: 'Finland', label: 'Finland' },
  { value: 'France', label: 'France' },
  { value: 'Gabon', label: 'Gabon' },
  { value: 'Gambia', label: 'Gambia' },
  { value: 'Georgia', label: 'Georgia' },
  { value: 'Germany', label: 'Germany' },
  { value: 'Ghana', label: 'Ghana' },
  { value: 'Greece', label: 'Greece' },
  { value: 'Guatemala', label: 'Guatemala' },
  { value: 'Guinea', label: 'Guinea' },
  { value: 'Haiti', label: 'Haiti' },
  { value: 'Honduras', label: 'Honduras' },
  { value: 'Hungary', label: 'Hungary' },
  { value: 'Iceland', label: 'Iceland' },
  { value: 'India', label: 'India' },
  { value: 'Indonesia', label: 'Indonesia' },
  { value: 'Iran', label: 'Iran' },
  { value: 'Iraq', label: 'Iraq' },
  { value: 'Ireland', label: 'Ireland' },
  { value: 'Israel', label: 'Israel' },
  { value: 'Italy', label: 'Italy' },
  { value: 'Jamaica', label: 'Jamaica' },
  { value: 'Japan', label: 'Japan' },
  { value: 'Jordan', label: 'Jordan' },
  { value: 'Kazakhstan', label: 'Kazakhstan' },
  { value: 'Kenya', label: 'Kenya' },
  { value: 'Kuwait', label: 'Kuwait' },
  { value: 'Kyrgyzstan', label: 'Kyrgyzstan' },
  { value: 'Laos', label: 'Laos' },
  { value: 'Latvia', label: 'Latvia' },
  { value: 'Lebanon', label: 'Lebanon' },
  { value: 'Lesotho', label: 'Lesotho' },
  { value: 'Liberia', label: 'Liberia' },
  { value: 'Libya', label: 'Libya' },
  { value: 'Liechtenstein', label: 'Liechtenstein' },
  { value: 'Lithuania', label: 'Lithuania' },
  { value: 'Luxembourg', label: 'Luxembourg' },
  { value: 'Madagascar', label: 'Madagascar' },
  { value: 'Malawi', label: 'Malawi' },
  { value: 'Malaysia', label: 'Malaysia' },
  { value: 'Maldives', label: 'Maldives' },
  { value: 'Mali', label: 'Mali' },
  { value: 'Malta', label: 'Malta' },
  { value: 'Mauritania', label: 'Mauritania' },
  { value: 'Mauritius', label: 'Mauritius' },
  { value: 'Mexico', label: 'Mexico' },
  { value: 'Moldova', label: 'Moldova' },
  { value: 'Monaco', label: 'Monaco' },
  { value: 'Mongolia', label: 'Mongolia' },
  { value: 'Montenegro', label: 'Montenegro' },
  { value: 'Morocco', label: 'Morocco' },
  { value: 'Mozambique', label: 'Mozambique' },
  { value: 'Myanmar', label: 'Myanmar' },
  { value: 'Namibia', label: 'Namibia' },
  { value: 'Nepal', label: 'Nepal' },
  { value: 'Netherlands', label: 'Netherlands' },
  { value: 'New Zealand', label: 'New Zealand' },
  { value: 'Nicaragua', label: 'Nicaragua' },
  { value: 'Niger', label: 'Niger' },
  { value: 'Nigeria', label: 'Nigeria' },
  { value: 'North Korea', label: 'North Korea' },
  { value: 'North Macedonia', label: 'North Macedonia' },
  { value: 'Norway', label: 'Norway' },
  { value: 'Oman', label: 'Oman' },
  { value: 'Pakistan', label: 'Pakistan' },
  { value: 'Palestine', label: 'Palestine' },
  { value: 'Panama', label: 'Panama' },
  { value: 'Papua New Guinea', label: 'Papua New Guinea' },
  { value: 'Paraguay', label: 'Paraguay' },
  { value: 'Peru', label: 'Peru' },
  { value: 'Philippines', label: 'Philippines' },
  { value: 'Poland', label: 'Poland' },
  { value: 'Portugal', label: 'Portugal' },
  { value: 'Qatar', label: 'Qatar' },
  { value: 'Romania', label: 'Romania' },
  { value: 'Russia', label: 'Russia' },
  { value: 'Rwanda', label: 'Rwanda' },
  { value: 'Saudi Arabia', label: 'Saudi Arabia' },
  { value: 'Senegal', label: 'Senegal' },
  { value: 'Serbia', label: 'Serbia' },
  { value: 'Sierra Leone', label: 'Sierra Leone' },
  { value: 'Singapore', label: 'Singapore' },
  { value: 'Slovakia', label: 'Slovakia' },
  { value: 'Slovenia', label: 'Slovenia' },
  { value: 'Somalia', label: 'Somalia' },
  { value: 'South Africa', label: 'South Africa' },
  { value: 'South Korea', label: 'South Korea' },
  { value: 'South Sudan', label: 'South Sudan' },
  { value: 'Spain', label: 'Spain' },
  { value: 'Sri Lanka', label: 'Sri Lanka' },
  { value: 'Sudan', label: 'Sudan' },
  { value: 'Sweden', label: 'Sweden' },
  { value: 'Switzerland', label: 'Switzerland' },
  { value: 'Syria', label: 'Syria' },
  { value: 'Taiwan', label: 'Taiwan' },
  { value: 'Tajikistan', label: 'Tajikistan' },
  { value: 'Tanzania', label: 'Tanzania' },
  { value: 'Thailand', label: 'Thailand' },
  { value: 'Togo', label: 'Togo' },
  { value: 'Trinidad and Tobago', label: 'Trinidad and Tobago' },
  { value: 'Tunisia', label: 'Tunisia' },
  { value: 'Turkey', label: 'Turkey' },
  { value: 'Turkmenistan', label: 'Turkmenistan' },
  { value: 'Uganda', label: 'Uganda' },
  { value: 'Ukraine', label: 'Ukraine' },
  { value: 'United Arab Emirates', label: 'United Arab Emirates' },
  { value: 'USA', label: 'United States' },
  { value: 'Uruguay', label: 'Uruguay' },
  { value: 'Uzbekistan', label: 'Uzbekistan' },
  { value: 'Venezuela', label: 'Venezuela' },
  { value: 'Vietnam', label: 'Vietnam' },
  { value: 'Yemen', label: 'Yemen' },
  { value: 'Zambia', label: 'Zambia' },
  { value: 'Zimbabwe', label: 'Zimbabwe' },
];

export const COUNTRY_OPTIONS = ALL_COUNTRIES;

// NOTE: The former hardcoded `STATES` map was removed in E1.8 / CSECR-64.
// State/province options now come from the DB-backed endpoint
// `GET /api/countries/{iso}/states` via the shared `useCountryStates` hook, so
// the list is admin-manageable and identical on every address form. Countries
// with no seeded rows fall back to a required free-text input.

const STATE_LABEL: Record<string, string> = {
  US: 'State',
  CA: 'Province / Territory',
  AU: 'State / Territory',
  GB: 'County',
};

export interface ApiCountry {
  id: string;
  name: string;
  iso_code: string;
  currency_code: string;
  currency_name: string;
  currency_symbol: string;
  phone_code: string;
}

interface AddressFieldsProps {
  country: string;
  state_province: string;
  city: string;
  postal_code: string;
  /** When omitted, the street address row is not rendered (caller renders it separately). */
  street_address?: string;
  errors: { country?: string; state_province?: string; city?: string; street_address?: string; postal_code?: string };
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  onCountryChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement | HTMLSelectElement>) => void;
  focusRing?: string;
  /** Override the base input/select className (default: dark-canvas dark theme). */
  inputClassName?: string;
  /** Override the label className (default: dark theme text-gray-200). */
  labelClassName?: string;
  /** Country list fetched from /countries API. When provided, replaces the fallback list. */
  countryOptions?: ApiCountry[];
  /** @deprecated Use countryOptions instead. */
  countries?: string[];
}

export default function AddressFields({
  country,
  state_province,
  city,
  postal_code,
  street_address,
  errors,
  onChange,
  onCountryChange,
  onBlur,
  focusRing = 'focus:ring-primary-500',
  inputClassName,
  labelClassName,
  countryOptions,
}: AddressFieldsProps) {
  const visibleCountries = countryOptions
    ? countryOptions.map(c => ({ value: c.iso_code, label: c.name }))
    : SUPPORTED_COUNTRIES;
  // State/province options are loaded from the DB-backed endpoint for the
  // selected country (E1.8 / CSECR-64). An empty list means the country has no
  // seeded subdivisions, so we render a required free-text input instead.
  const { states: dbStates, loading: statesLoading } = useCountryStates(country);
  const stateOptions = dbStates.map(s => ({ value: s.code, label: s.name }));
  const stateLabel   = STATE_LABEL[country] ?? 'State / Province';
  const baseInput    = inputClassName ?? `w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 ${focusRing} border-dark-border bg-dark-canvas text-gray-200 placeholder-dark-muted`;
  const baseLabel    = labelClassName ?? 'block text-sm font-medium text-gray-200 mb-1';
  const errorBorder  = 'border-red-500';

  return (
    <div className="space-y-4">
      {/* Country first */}
      <div>
        <label htmlFor="country" className={baseLabel}>
          Country *
        </label>
        <select
          id="country"
          name="country"
          value={country}
          onChange={onCountryChange}
          onBlur={onBlur}
          className={`${baseInput} ${errors.country ? errorBorder : ''}`}
        >
          <option value="">Select a country…</option>
          {visibleCountries.map(c => (
            <option key={c.value} value={c.value}>{c.label}</option>
          ))}
        </select>
        {errors.country && <p className="text-red-500 text-sm mt-1">{errors.country}</p>}
      </div>

      {/* State / Province — dropdown if we have data, otherwise free-form */}
      {country && (
        <div>
          <label htmlFor="state_province" className={baseLabel}>
            {stateLabel} *
          </label>
          {stateOptions.length > 0 ? (
            <select
              id="state_province"
              name="state_province"
              value={state_province}
              onChange={onChange}
              onBlur={onBlur}
              className={`${baseInput} ${errors.state_province ? errorBorder : ''}`}
            >
              <option value="">Select {stateLabel.toLowerCase()}…</option>
              {stateOptions.map(s => (
                <option key={s.value} value={s.value}>{s.label}</option>
              ))}
            </select>
          ) : (
            <input
              type="text"
              id="state_province"
              name="state_province"
              value={state_province}
              onChange={onChange}
              onBlur={onBlur}
              className={`${baseInput} ${errors.state_province ? errorBorder : ''}`}
              placeholder={statesLoading ? 'Loading…' : `Enter ${stateLabel.toLowerCase()}`}
            />
          )}
          {errors.state_province && <p className="text-red-500 text-sm mt-1">{errors.state_province}</p>}
        </div>
      )}

      {/* Street Address — only rendered when caller passes the prop */}
      {street_address !== undefined && (
        <div>
          <label htmlFor="street_address" className={baseLabel}>
            Street Address <span className="text-gray-400 font-normal">(optional)</span>
          </label>
          <input
            type="text"
            id="street_address"
            name="street_address"
            value={street_address}
            onChange={onChange}
            onBlur={onBlur}
            className={`${baseInput} ${errors.street_address ? 'border-red-500' : ''}`}
            placeholder="Enter street address"
          />
          {errors.street_address && <p className="text-red-500 text-sm mt-1">{errors.street_address}</p>}
        </div>
      )}

      {/* City + Postal Code */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label htmlFor="city" className={baseLabel}>
            City *
          </label>
          <input
            type="text"
            id="city"
            name="city"
            value={city}
            onChange={onChange}
            onBlur={onBlur}
            className={`${baseInput} ${errors.city ? errorBorder : ''}`}
            placeholder="Enter city"
          />
          {errors.city && <p className="text-red-500 text-sm mt-1">{errors.city}</p>}
        </div>

        <div>
          <label htmlFor="postal_code" className={baseLabel}>
            Postal Code {errors.postal_code !== undefined ? '*' : <span className="text-gray-400 font-normal">(optional)</span>}
          </label>
          <input
            type="text"
            id="postal_code"
            name="postal_code"
            value={postal_code}
            onChange={onChange}
            onBlur={onBlur}
            className={`${baseInput} ${errors.postal_code ? 'border-red-500' : ''}`}
            placeholder="Enter postal code"
          />
          {errors.postal_code && <p className="text-red-500 text-sm mt-1">{errors.postal_code}</p>}
        </div>
      </div>
    </div>
  );
}
